import { DropdownMenuItem } from "@certa/catalyst/components/Dropdown";
import { useLocation, useNavigate } from "react-router";
import {
  getStudioGenericRoute,
  getStudioObjectsRouteWithoutStage
} from "../../../../../utils/routes";
import { WrapperWithIcon } from "../common";
import { Database } from "@certa/icons/components/Database";
import { useIntl } from "react-intl";
import { analyticsService, AnalyticsEvents } from "@certa/analytics";
import { useCanViewStudioObjects } from "../../../../../hooks/useCanViewStudio2";

export const RecordsDropdownItem = () => {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const hasPermissions = useCanViewStudioObjects();

  const shouldShowRecords =
    location.pathname.startsWith(getStudioGenericRoute()) && hasPermissions;

  const handleSelect = () => {
    analyticsService.track(
      AnalyticsEvents.headerEvents.HEADER_CLICK_USERPROFILE_RECORDS
    );
    navigate(getStudioObjectsRouteWithoutStage());
  };
  if (!shouldShowRecords) {
    return null;
  }
  return (
    <DropdownMenuItem key="records" value="Records" onSelect={handleSelect}>
      <WrapperWithIcon icon={<Database />}>
        {intl.formatMessage({
          id: "navigation.Records",
          defaultMessage: "Records"
        })}
      </WrapperWithIcon>
    </DropdownMenuItem>
  );
};
